//modules
import React from 'react';

//styles
import './RightsFooter.css';

export const RightsFooter = ( { customClass }) => {

  return (
    <div className={`rights footer ${customClass || ''}`}>
        <p className="caption">© 2026 ·  Designed and developed by Valentina Garcia Aiello. </p>
        <p className="caption right-alignment">Version 1.3</p>
    </div>
  );
};
